import React  from "react";
import Modal from 'react-bootstrap/Modal';

const ModalFooter = (props) => {

    const { children } = props
    return (
        <Modal.Footer>
            {children}
        </Modal.Footer>
    )
}

export default ModalFooter;